import React, { Component } from 'react';
import animateScrollTo from 'animated-scroll-to';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

class WorkWithUsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            linkCurriculum: '',
            email: '',
            name: '',
            lastName: '',
            tel: '',
            text: '',
            textoCargo: '',
            touched: {
                linkCurriculum: false,
                email: false,
                name: false,
                lastName: false,
                tel: false,
                text: false,
                textoCargo: false,
            },
        };

        this.validationRules = {
            // eslint-disable-next-line max-len
            emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            emailMaxLength: 30,
            nameRegex: /^[a-z\u00C0-\u017F\s ]+$/i,
            nameMinLength: 3,
            nameMaxLength: 20,
            lastNameRegex: /^[a-z\u00C0-\u017F\s ]+$/i,
            lastNameMinLength: 3,
            lastNameMaxLength: 30,
            telMinLength: 13,
            telMaxLength: 15,
            textoCargoMinLength: 3,
            textoCargoMaxLength: 50,
            aboutYouMinLength: 3,
            aboutYouMaxLength: 1000,
            linkCurriculumRegex: /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,}(\/\S*)?$/i,
        };
    }

    componentDidMount() {
        animateScrollTo(0, { speed: 700 });
    }

    handleEmailChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            email: evt.target.value,
            touched: { ...tempTouched, email: true },
        });
    }

    handleNameChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            name: evt.target.value,
            touched: { ...tempTouched, name: true },
        });
    }

    handleLastNameChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            lastName: evt.target.value,
            touched: { ...tempTouched, lastName: true },
        })
    }

    handleTelChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            tel: evt.target.value,
            touched: { ...tempTouched, tel: true },
        });
    }

    handleTextChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            text: evt.target.value,
            touched: { ...tempTouched, text: true },
        });
    }

    handleTextoCargoChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            textoCargo: evt.target.value,
            touched: { ...tempTouched, textoCargo: true },
        });
    }

    handleLinkCurriculumChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            linkCurriculum: evt.target.value,
            touched: { ...tempTouched, linkCurriculum: true },
        });
    }

    handleSubmit = (evt) => {
        evt.preventDefault();

        if (!this.canBeSubmitted()) {
            return;
        }

        const { touched, ...restState } = this.state;

        this.props.sendCurriculum(restState);
    }

    canBeSubmitted() {
        // eslint-disable-next-line max-len
        const errors = this._validate(this.state.email, this.state.name, this.state.lastName, this.state.tel, this.state.text, this.state.textoCargo, this.state.linkCurriculum);
        const isDisabled = Object.keys(errors).some((x) => errors[x]);

        return !isDisabled;
    }

    _validate(email, name, lastName, tel, text, textoCargo, linkCurriculum) {
        const emailValid = email.match(this.validationRules.emailRegex) != null && email.length <= this.validationRules.emailMaxLength;
        // eslint-disable-next-line max-len
        const nameValid = name.match(this.validationRules.nameRegex) != null && name.length >= this.validationRules.nameMinLength && name.length <= this.validationRules.nameMaxLength;

        // eslint-disable-next-line max-len
        const lastNameValid = lastName.match(this.validationRules.lastNameRegex) != null && lastName.length >= this.validationRules.lastNameMinLength && lastName.length <= this.validationRules.lastNameMaxLength;
        const telValid = tel.length >= this.validationRules.telMinLength && tel.length <= this.validationRules.telMaxLength;
        // eslint-disable-next-line max-len
        const textoCargoValid = textoCargo.length >= this.validationRules.textoCargoMinLength && textoCargo.length <= this.validationRules.textoCargoMaxLength;
        const textValid = text.length >= this.validationRules.aboutYouMinLength && text.length <= this.validationRules.aboutYouMaxLength;
        const linkCurriculumValid = !linkCurriculum || this.validationRules.linkCurriculumRegex.test(linkCurriculum);

        // returning validation ERRORS!
        return {
            email: !emailValid,
            text: !textValid,
            name: !nameValid,
            lastName: !lastNameValid,
            tel: !telValid,
            textoCargo: !textoCargoValid,
            linkCurriculum: !linkCurriculumValid,
        };
    }

    render() {
        // eslint-disable-next-line max-len
        const errors = this._validate(this.state.email, this.state.name, this.state.lastName, this.state.tel, this.state.text, this.state.textoCargo, this.state.linkCurriculum);
        const isDisabled = Object.keys(errors).some((x) => errors[x]) || this.props.submitting;
        let emailRed = this.state.touched.email;

        if (emailRed) {
            emailRed = errors.email;
        }

        let nameRed = this.state.touched.name;

        if (nameRed) {
            nameRed = errors.name;
        }

        let lastNameRed = this.state.touched.lastName;

        if (lastNameRed) {
            lastNameRed = errors.lastName;
        }

        let telRed = this.state.touched.tel;

        if (telRed) {
            telRed = errors.tel;
        }

        let textRed = this.state.touched.text;

        if (textRed) {
            textRed = errors.text;
        }

        let textoCargoRed = this.state.touched.textoCargo;

        if (textoCargoRed) {
            textoCargoRed = errors.textoCargo;
        }

        let linkCurriculumRed = this.state.touched.linkCurriculum;

        if (linkCurriculumRed) {
            linkCurriculumRed = errors.linkCurriculum;
        }

        // const limitCountError = this.state.text.length < this.validationRules.aboutYouMaxLength ? '' : 'limitCountError';

        return (
            <section className="sectionWWU">
                <header>
                    <h1>Trabalhe Conosco</h1>
                    <p className="tw-text-black tw-normal-case tw-text-center">Quer fazer parte da equipe? Então esse é o lugar certo.</p>
                </header>
                <form className="workUsForm" onSubmit={this.handleSubmit}>
                    <div className="gridContainer">
                        <div className="form-group">
                            <label htmlFor="firstName">Nome</label>
                            <input
                                id="firstName"
                                name="firstName"
                                className={nameRed ? 'error nameInput' : 'nameInput'}
                                type="text"
                                value={this.state.name}
                                onChange={this.handleNameChange}
                                disabled={this.props.submitted}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="lastName">Sobrenome</label>
                            <input
                                id="lastName"
                                name="lastName"
                                className={lastNameRed ? 'error lastNameImput' : 'lastNameInput'}
                                type="text"
                                value={this.state.lastName}
                                onChange={this.handleLastNameChange}
                                disabled={this.props.submitted}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">Telefone</label>
                            <InputMask
                                id="phone"
                                name="phone"
                                className={telRed ? 'error telInput' : 'telInput'}
                                mask="(99) 99999-9999"
                                maskChar={null}
                                type="tel"
                                value={this.state.tel}
                                onChange={this.handleTelChange}
                                disabled={this.props.submitted}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                name="email"
                                className={emailRed ? 'error emailInput' : 'emailInput'}
                                type="email"
                                value={this.state.email}
                                onChange={this.handleEmailChange}
                                disabled={this.props.submitted}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="position">Cargo</label>
                            <input
                                id="position"
                                name="position"
                                className={textoCargoRed ? 'error textoCargoInput' : 'textoCargoInput'}
                                type="text"
                                value={this.state.textoCargo}
                                onChange={this.handleTextoCargoChange}
                                disabled={this.props.submitted}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="linkCurriculum">Link do currículo (opcional)</label>
                            <input
                                id="linkCurriculum"
                                name="linkCurriculum"
                                className={linkCurriculumRed ? 'error linkCurriculumInput' : 'linkCurriculumInput'}
                                type="text"
                                placeholder="ex: linkedin.com/in/seu-perfil"
                                value={this.state.linkCurriculum}
                                onChange={this.handleLinkCurriculumChange}
                                disabled={this.props.submitted}
                            />
                        </div>
                        <div className="form-group full-width">
                            <label htmlFor="message">Fale sobre você</label>
                            <textarea
                                id="message"
                                name="message"
                                className={textRed ? 'error textInput' : 'textInput'}
                                value={this.state.text}
                                onChange={this.handleTextChange}
                                disabled={this.props.submitted}
                            />
                        </div>
                    </div>
                    <div className="tw-flex tw-items-center tw-justify-center tw-flex-col">
                        <p>Preencha todos os campos para enviar sua mensagem. </p>
                        {
                            !this.props.submitted && (
                                <button type="submit" className={isDisabled ? 'submitButtonDisabled' : 'submitButtonEnabled'} disabled={isDisabled || this.props.submitted}>
                                    {this.props.submitting ? 'ENVIANDO' : 'Enviar'}
                                </button>
                            )
                        }
                    </div>
                </form>
            </section>
        );
    }
}

WorkWithUsComponent.propTypes = exact({
    sendCurriculum: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
});

export default WorkWithUsComponent;
